import { PlayerRanking, SchoolRanking, TournamentGenderEnum } from '@spikemark/rest-api';

export enum RankingType {
  Player = 'Player',
  Team = 'Team',
}

export type Ranking = {
  season: string;
  gender: TournamentGenderEnum;
  division: string;
  conference?: string;
  region?: string;
  lastUpdated?: string;
} & (
  | {
      rankingType: RankingType.Player;
      leaderboard: PlayerRanking[];
    }
  | {
      rankingType: RankingType.Team;
      leaderboard: SchoolRanking[];
    }
);
